let prevIsMobile = null;
let prevLayout = null;
let resizeTimer;

function initSlider($slider) {
  const $cards = $slider.find('.multicard-slider');
  const totalCards = $cards.length;
  const isMobile = window.innerWidth < 768;
  const $wrapper = $slider.closest('.multicard-module-container');
  const $buttonContainer = $wrapper.find('.buttons-container');
  const $prevArrow = $wrapper.find('.slick-prev');
  const $nextArrow = $wrapper.find('.slick-next');
  let layout = $wrapper.data('layout');
  const shape = $wrapper.data('shape');
  let defaultLayout = '';

  if (isMobile) {
    defaultLayout = totalCards > 3 ? 'carousel' : 'stack';
  } else {
    defaultLayout = totalCards > 4 ? 'carousel' : 'stack';
  }

  if (shape === 'vertical') {
    $slider.find('.img-card img').css('height', isMobile ? '450px' : '533px');
  } else if (shape === 'horizontal') {
    $slider.find('.img-card img').css('height', isMobile ? '200px' : '267px');
  } else {
    $slider.find('.img-card img').css('height', 'auto');
  }

  layout = layout || defaultLayout;

  if ($slider.data('prevLayout') === layout && $slider.data('prevIsMobile') === isMobile) return;

  $slider.data('prevLayout', layout);
  $slider.data('prevIsMobile', isMobile);

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.removeClass('stack-layout no-padding-right more-than-5 only-3-cards');
  $buttonContainer.hide();

  if (isMobile) {
    if ((layout === 'carousel' && totalCards > 3) || (shape === 'vertical' && totalCards >= 3)) {
      $slider.on('init', function () {
        $slider.addClass('no-padding-right');
        $buttonContainer.show();
      });

      $slider.slick({
        slidesToShow: 1.2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        draggable: true,
        swipe: true,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
      });

    } else {
      $slider.addClass('stack-layout');
    }
  } else {
    if (totalCards === 3) {
      $slider.addClass('only-3-cards');
    }

    if (layout === 'carousel' && totalCards > 4) {
      $slider.on('init', function () {
        $slider.addClass('no-padding-right more-than-5');
        $buttonContainer.show();
      });

      $slider.slick({
        slidesToShow: 3.2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        draggable: true,
        swipe: true,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2.2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
            },
          },
        ],
      });
    }
  }
}

function initCardSlider($slider) {
  const totalCards = $slider.find('.card-slider').length;
  const isMobile = window.innerWidth < 768;
  const $wrapper = $slider.closest('.multicard-module-container');
  const $buttonContainer = $wrapper.find('.buttons-container');
  const $prevArrow = $wrapper.find('.slick-prev');
  const $nextArrow = $wrapper.find('.slick-next');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $buttonContainer.hide();

  if (isMobile && totalCards > 2) {
    $slider.slick({
      slidesToShow: 1.1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      draggable: true,
      swipe: true,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
    });
    $buttonContainer.show();
  } else if (!isMobile && totalCards > 3) {
    $slider.on('init', function () {
      $buttonContainer.show();
    });

    $slider.slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      draggable: true,
      swipe: true,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.4,
          },
        },
      ],
    });
  }
}

$(document).ready(function () {
  $('.multicard-slick-slider').each(function () {
    initSlider($(this));
  });

  $('.card-slick-slider').each(function () {
    initCardSlider($(this));
  });
});

window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    $('.multicard-slick-slider').each(function () {
      initSlider($(this));
    });

    $('.card-slick-slider').each(function () {
      initCardSlider($(this));
    });
  }, 150);
});
